module.exports = __webpack_public_path__ + "static/media/icon-electronics-full.f70af9e0.png";